import React from 'react';
import classnames from 'classnames'
import ModalInner from '../layoutItems/modalInner';
import { withLocalize, Translate } from 'react-localize-redux';
import { Formik, Form, Field } from "formik";
import BbRadioWrapper from "../styling/BbRadioWrapper";
import { apiGet, getHostApi } from '../../store/apiWrapper';
import BbCheckbox from "../../components/styling/bbCheckbox";
import { Circles } from "../../components/common/loadingComponent";
import { formatDate } from 'react-day-picker/moment';
import Paging from "../../components/common/pagingComponent";
import { validateInput } from '../../store/storeFunctions';

class CustomSearchPopup extends React.Component {

    defaultValues = {
        searchTxt: '',
        searchType: 'Existing'
    }

    page = 1;
    pageSize = 10;

    constructor(props) {
        super(props);
        this.state = {
            subjects: null,
            isLoading: false,
            selectedSubject: null,
            totalCount: 0
        };
    }

    render() {
        return (
            <ModalInner title={this.props.translate('Charts.SearchSubjects')} close={this.props.close}>
                <Formik
                    initialValues={this.defaultValues}
                    enableReinitialize={true}
                >
                    {({ setFieldValue, values }) => (
                        <Form>
                            <div className="columns is-vcentered">
                                <div className="column is-9">
                                    <Field className="input" type="text" name="searchTxt" style={{ width: '100%' }} maxLength="100" onInput={(e) => validateInput(e)} />
                                </div>
                                <div className="column is-3 has-text-centered">
                                    <button type="button" onClick={() => { this.search(values.searchTxt, values.searchType, true) }} className={classnames('bb-button small gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Charts.Search" /></button>
                                </div>
                            </div>
                            <div className="columns">
                                <div className="control">
                                    <BbRadioWrapper callback={() => setFieldValue("searchType", 'Existing')}
                                        checked={values.searchType === 'Existing'}
                                        name="searchType"
                                        id="searchTypeExisting"
                                        value='Existing' label={this.props.translate("Charts.ExistingEntity")} />
                                </div>
                                <div className="control">
                                    <BbRadioWrapper callback={() => setFieldValue("searchType", 'Own')}
                                        checked={values.searchType === 'Own'}
                                        name="searchType"
                                        id="searchTypeOwn"
                                        value='Own' label={this.props.translate("Charts.CustomEntity")} />
                                </div>
                            </div>

                            {this.state.isLoading && <div style={{ paddingTop: '20px' }}><Circles position="static" /></div>}

                            {this.state.subjects &&
                                <div className="columns is-centered" style={{ flexDirection: "column", paddingTop: '15px' }}>
                                    <h2 style={{ textAlign: "center" }}><Translate id="Charts.Count" />: {this.state.totalCount}</h2>
                                    <table className="table table-report-section with-ellipsed-column" style={{ fontSize: "0.8em" }}>
                                        <thead>
                                            <tr>
                                                <td style={{ width: "5%" }}></td>
                                                <td style={{ width: "10%" }}><Translate id="Monitoring.Add.CompanyId" />/<Translate id="Charts.AddEntityDateOfBirth" /></td>
                                                <td style={{ width: "85%" }}><Translate id="Common.Title" /></td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.subjects.map((s, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td><BbCheckbox id={`${i}-chk`} value={this.state.selectedSubject != null && this.state.selectedSubject.entityId === s.entityId} onChange={(v) => this.onSingleClick(v, s.entityId)} /></td>
                                                        <td>{s.ico || (s.dateOfBirth ? formatDate(s.dateOfBirth, 'DD.MM.YYYY', 'cs') : '')}</td>
                                                        <td className='ellipsed-column'>
                                                            <div><b>{s.queryName}</b>{s.creator ? ` (${s.creator})` : ''}</div>
                                                            <div>{s.address}</div>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                    {(Math.ceil(this.state.totalCount / this.pageSize) > 1) ? (
                                        <div className='column is-centered paging-root'>
                                            <Paging selectedPage={this.page}
                                                totalPages={Math.ceil(this.state.totalCount / this.pageSize)}
                                                setPage={page => {
                                                    this.page = page;
                                                    this.search(values.searchTxt, values.searchType, false);
                                                }} />
                                        </div>
                                    ) : null}
                                </div>
                            }

                            <div className="modal-inner-buttons" style={{ paddingTop: "1em" }}>
                                <button type="button" disabled={this.state.selectedSubject == null} onClick={() => { this.openRelationPopup() }} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Charts.Add" /></button>
                                <button type="button" onClick={() => { this.props.newCustomEntity(); this.props.close() }} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Charts.AddOwnEntity" /></button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </ModalInner>
        )
    }

    onSingleClick(val, entityId) {
        if (val) {
            this.setState({
                selectedSubject: this.state.subjects.filter((s) => { return s.entityId === entityId })[0]
            });
        }
        else {
            this.setState({ selectedSubject: null });
        }
    }

    search(searchTxt, searchType, newSearch) {
        if (newSearch) {
            this.page = 1;
            this.setState({ selectedSubject: null });
        }
        this.setState({ isLoading: true, subjects: [], totalCount: 0 });
        if (searchType === 'Existing')
            apiGet(`${getHostApi()}/api/search/quick`, { query: searchTxt, offset: (this.page - 1) * this.pageSize, size: this.pageSize },
                (data) => {
                    data.data.subjects.forEach((s) => s.ico = s.ico ? s.ico.replace('<em>', '').replace('</em>', '') : null);
                    this.setState({ isLoading: false, subjects: data.data.subjects, totalCount: data.data.totalFound });
                });
        else {
            apiGet(`${getHostApi()}/api/charts/search-custom-subjects`, { query: searchTxt, page: this.page, pageSize: this.pageSize },
                (data) => {
                    this.setState({ isLoading: false, subjects: data.data.subjects, totalCount: data.data.totalFound });
                });
        }
    }

    openRelationPopup() {
        this.props.newCustomRelation({ Name: this.state.selectedSubject.queryName, EntityID: this.state.selectedSubject.entityId });
        this.props.close();
    }

}

export default withLocalize(CustomSearchPopup);
